module.exports = __webpack_public_path__ + "img/img4@2x.caacba4a.png";